import React, { useState, useContext } from "react";
import BannerSection from "../../inc/BannerSection";
import Banner from "../../images/banner.jpg";
import TherapistSidebar from "../../inc/TherapistSidebar";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import BankImage from "../../images/bank1.svg";
import { Image } from "react-bootstrap";
import { FaAlignLeft } from "react-icons/fa";
import { AuthContext } from "../../../utility/services/AuthContext";
import Functions from "../../../utility/services/Functions";
import { toast } from "react-toastify";
import ApiService from "../../../utility/services/ApiService";
import ConstConfig from "../../../utility/configs/constConfig";

const TherapistBankConnected = () => {
  const [filterHideShow, setfilterHideShow] = useState(false);

  const { setLoading } = useContext(AuthContext);
  const { create_stripe_account } = ApiService();
  const { consoleService } = Functions();

  const sideBarHide = () => {
    setfilterHideShow(!filterHideShow);
  };

  async function createStripeAccount() {
    setLoading(true);
    try {
      const res = await create_stripe_account();
      if (res.status === 1) {
        setLoading(false);
        window.location.replace(res.data);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in createStripeAccount function", err);
    }
  }

  return (
    <>
      <div className="breadHidePhone">
        <BannerSection banner={Banner} name={"Home"} title={"Bank Details"} />
      </div>
      <section className="py-5 useraccount bg-light_dash">
        <div className="container">
          <div className="row">
            <div
              className={`col-xl-3 col-md-4 ${
                filterHideShow ? "leftShow" : "leftHide"
              }`}
            >
              <TherapistSidebar />
            </div>
            <div className="col-xl-9 col-md-8 fulltabBox connect_bank_fulltabBox">
              <div className="filterBox">
                <Link className="filterIcon" onClick={sideBarHide}>
                  <FaAlignLeft />
                </Link>
              </div>
              <div className="dashboard-widg-bar d-block">
                <div className="dashboard_body">
                  <h4 className="mb-4 ft-medium">Bank Details</h4>
                  <div className="bankBox">
                    <Image
                      src={BankImage}
                      alt=""
                      className="stripe_img img-fluid"
                    />

                    <div className="under_bank_box">
                      <h2>You are Connected</h2>

                      <Button
                        as={Link}
                        to="/therapistbankdetails"
                        className="btn btn-primary me-3"
                        onClick={() => {
                          createStripeAccount();
                        }}
                      >
                        Change bank details
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TherapistBankConnected;
